/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".shell[_ngcontent-%COMP%]{display:flex;height:100vh;overflow:hidden}.shell[_ngcontent-%COMP%]   .sidebar[_ngcontent-%COMP%]{background-color:#293348;min-width:128px;max-width:128px}.shell[_ngcontent-%COMP%]   .main[_ngcontent-%COMP%]{flex-grow:1;overflow:hidden}.shell[_ngcontent-%COMP%]   .main[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{overflow-y:auto;height:calc(100vh - 112px)}.shell[_ngcontent-%COMP%]   .main[_ngcontent-%COMP%]   .content.action-bar-visible[_ngcontent-%COMP%]{height:calc(100vh - 112px - 88px)}"];
export { styles as styles };
